<template>
  <SkDropdownSelect
    v-model="timeslot"
    :options="timeslots"
    @selected="timeSelected"
    ref="dropdown"/>
</template>

<style scoped>
  * >>> .options {
    max-height: 250px;
  }
</style>

<script>
import momentUtils from "@/moment-utils"
import moment from "moment"
import SkDropdownSelect from "@/components/common/SkDropdownSelect.vue"
export default {
  name: "DeliveryTimePicker",
  components: {
    SkDropdownSelect
  },
  props: {
    schedule: Object,
    currentDate: null,
    value: null
  },
  data: function() {
    return {
      timeslots: [],
      timeslot: null,
      dirty: false
    }
  },
  computed: {
    model:{
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    }
  },
  mounted: function() {
    this.generateTimeTable()
  },
  methods: {
    timeSelected(timeslot) {
      this.dirty = true
      this.updateModel(timeslot)
    },
    generateTimeTable() {
      let timeslots = []
      let addedSlots = []
      if (this.currentDate) {
        let date = moment(this.currentDate)
        let dow = momentUtils.normalizeDayOfWeek(date)
        let today = moment().add(1, "hour")
        let todaysDow = momentUtils.todaysDow()
        const isToday = todaysDow == dow
        this.schedule[dow].forEach(schedule => {
          const slots = this.generateTimeSlots(schedule, addedSlots, isToday, today)
          timeslots = timeslots.concat(slots)
        })
      }
      this.timeslots = timeslots.sort((a, b) => a.weight - b.weight)
      if (!this.dirty && !this.$store.getters.fullPreorderDate) {
        this.timeslot = timeslots[0]
        this.updateModel(this.timeslot)
      } else {
        const selectedTimeIndex = timeslots.findIndex(slot => slot.value == this.model)
        if (selectedTimeIndex > -1) {
          this.timeslot = timeslots[selectedTimeIndex]
        } else {
          this.timeslot = timeslots[0]
        }
        this.updateModel(this.timeslot)
      }
    },
    generateTimeSlots(schedule, addedSlots, isToday, today) {
      let timeslots = []
      const openTime = moment(schedule.openTime, "HH:mm")
      const closeTime = moment(schedule.closeTime, "HH:mm")
      const intervals = closeTime.diff(openTime, "minutes") / 15
      for (var i = 0; i < intervals; i++) {
        let date = moment(openTime, "HH:mm").add(i * 15, "minutes")
        if (isToday && date.isBefore(today)) {
          continue
        }
        const numerical = momentUtils.numericalTime(date.format("HH:mm"))
        let slot = {
          text: date.format("h:mm A"),
          value: date.format("HH:mm:ss"),
          date: date,
          weight: numerical,
          id: numerical
        }
        if (addedSlots.includes(slot.value)) {
          continue
        }
        timeslots.push(slot)
        addedSlots.push(slot.value)
      }
      return timeslots
    },
    updateModel(timeslot) {
      if (timeslot) {
        this.model = timeslot.value
      }
    },
  },
  watch: {
    schedule() {
      this.generateTimeTable()
    },
    currentDate() {
      this.generateTimeTable()
    }
  }
}
</script>